var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CSidebar',{attrs:{"hideOnMobileClick":false,"show":_vm.show,"id":"sidebar"},on:{"update:show":function($event){_vm.show=$event}}},[_c('CSidebarBrand',[_c('img',{staticClass:"logo-container",attrs:{"src":_vm.logoImage,"alt":"brand logo image"}})]),_c('CRenderFunction',{attrs:{"flat":"","content-to-render":_vm.nav}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }